<template>
    <div v-if="pendingApprovals.modifications.length === 0" class="py-4">
        Keine Offenen Freigaben
    </div>

    <table class="min-w-full divide-y divide-gray-200 mt-2 md:mt-4" v-if="pendingApprovals.modifications.length > 0">
        <tbody class="bg-white divide-y divide-gray-200">
            <tr v-for="modification in pendingApprovals.modifications" :key="modification.uuid">
                <td class="px-1 py-2 md:py-3 whitespace-nowrap text-sm font-medium text-gray-900">
                    <Link :href="modification.modificationLink">
                    <span v-if="modification.dotColor && $page.props.deadline_indicator_show_in_apartment_dashboard" 
                        class="hidden md:inline-block mr-2 h-3 w-3 rounded-full bg-current relative -bottom-[0.08rem]" 
                        :class="[!modification.dotColor.startsWith('#') ? modification.dotColor : '']"
                        :style="modification.dotColor.startsWith('#') ? { color: modification.dotColor } : {}">
                    </span>
                    <span>{{ modification.title }}</span>
                    <span> - {{ modification.topicName }}</span>
                    </Link>
                </td>
                <td class="px-1 py-2 md:py-3 whitespace-nowrap text-sm text-gray-900 text-right">
                    {{ displayCost(modification) }}
                </td>
                <td class="hidden md:table-cell py-2 md:py-3 whitespace-nowrap text-sm text-gray-900 text-center">
                </td>
            </tr>
        </tbody>
        <tfoot class="border-top">
            <tr v-if="hasTotal">
                <td class="px-1 py-2 md:py-3 whitespace-nowrap text-sm font-bold text-gray-900">
                    {{ $t("apartments.total") }}
                </td>
                <td class="px-1 py-2 md:py-3 whitespace-nowrap text-sm font-bold text-gray-900 text-right">
                    {{ pendingApprovals.total }}
                </td>
                <td class="hidden md:table-cell"></td>
            </tr>
        </tfoot>
    </table>
</template>

<script>
import { CloudDownloadIcon } from "@heroicons/vue/outline";
import { Link } from "@inertiajs/inertia-vue3";

// Fix Gesamt-Gate Welle 2 (W2): `pendingApprovals.total` wird serverseitig
// genullt, sobald die Spalte "mehrkosten" für den Käufer gesperrt ist
// (Thema 1, `ApartmentShowResource`). Roh gerendert stand dann ein fettes
// "Total" ohne Betrag in der Box — die ganze Total-Zeile entfällt darum bei
// fehlendem Wert, analog `hasFooterTotal` in `ApartmentBudgetTable.vue`.
// `0` bzw. "0.00" bleibt ein gültiger Wert und wird weiterhin gezeigt.
//
// GATE-BEFUND B-1 (UI-Abnahme, 23.09.2026): die Zeile zeigt `costWithFees`,
// also den Betrag MIT Gebuehr und Honorar — denselben, den die Entscheidseite
// nennt, auf die von hier aus geklickt wird. Bis hierhin stand in diesem
// Kasten die blanke Offertensumme, und der Kaeufer las auf EINEM Bildschirm
// drei Zahlen fuer dieselben zwei Aenderungen (3'797.65 hier, 4'348.40 in der
// Abrechnung darunter, 3'708.70 auf der Entscheidseite).
//
// Der Server summiert die Fusszeile im selben Zug ueber dieselbe Spalte
// (`ApartmentShowResource`, `sumTotalsWithFeesRounded()`). Wer eine der
// beiden Seiten aendert, aendert die andere mit — sonst addiert die Tabelle
// ihre eigenen Zeilen nicht mehr (Gate-Befund BL-1).
export default {
    props: ["pendingApprovals"],
    components: {
        Link,
        CloudDownloadIcon
    },
    computed: {
        hasTotal() {
            return (
                this.pendingApprovals.total !== null &&
                this.pendingApprovals.total !== undefined
            );
        }
    },
    methods: {
        // Wortgleich `OrderModificationTable.displayCost()`. `??` und nicht
        // `||`: der Server liefert einen formatierten String, und "0.00" ist
        // in JavaScript wahr — an DIESER Grenze sind die beiden nicht
        // unterscheidbar, die Absicht ist es aber. Fehlt der Opt-in (kein
        // `costWithFees`), bleibt die Zeile wie bisher bei `cost`.
        displayCost(modification) {
            return modification.costWithFees ?? modification.cost;
        }
    }
};
</script>

<style scoped></style>
